import axios from 'axios'

export const fetchFooterDetails = () => {
  return axios.get('/footer')
}

export const fetchFooterPageDetails = (id) => {
  return axios.get(`/footer/${id}`)
}
